import { render, staticRenderFns } from "./NewNotification.vue?vue&type=template&id=10eb8c0a"
import script from "./NewNotification.vue?vue&type=script&lang=js"
export * from "./NewNotification.vue?vue&type=script&lang=js"
import style0 from "./NewNotification.vue?vue&type=style&index=0&id=10eb8c0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports